import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getTermsStatus } from '../api/terms';

const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const [checkingTerms, setCheckingTerms] = useState(true);
  const [requiresReagreement, setRequiresReagreement] = useState(false);

  const isReagreementPage = location.pathname === '/terms/reagreement';

  useEffect(() => {
    let cancelled = false;

    if (!user) {
      setCheckingTerms(false);
      setRequiresReagreement(false);
      return;
    }

    if (isReagreementPage) {
      setCheckingTerms(false);
      setRequiresReagreement(false);
      return;
    }

    const checkStatus = async () => {
      setCheckingTerms(true);
      try {
        const status = await getTermsStatus();
        if (!cancelled) {
          setRequiresReagreement(!!status?.requires_reagreement);
        }
      } catch (e) {
        if (!cancelled) {
          // 通信失敗時にアプリを全面停止させないため、通常遷移は許可
          setRequiresReagreement(false);
        }
      } finally {
        if (!cancelled) setCheckingTerms(false);
      }
    };

    checkStatus();

    return () => {
      cancelled = true;
    };
  }, [user, isReagreementPage]);

  if (!user) {
    // ユーザー情報がなければログイン画面へ
    return <Navigate to="/login" replace />;
  }

  if (checkingTerms) {
    return null;
  }

  if (requiresReagreement && !isReagreementPage) {
    const rawNext = `${location.pathname}${location.search || ''}`;
    let safeNext = '/profile/my';
    try {
      const url = new URL(rawNext, window.location.origin);
      if (url.origin === window.location.origin) safeNext = rawNext;
    } catch {
      // フォールバック
    }
    return <Navigate to={`/terms/reagreement?next=${encodeURIComponent(safeNext)}`} replace />;
  }

  // ユーザーがいればそのまま子要素を表示
  return children;
};

export default PrivateRoute;
